import "antd/es/input/style";
import _Input from "antd/es/input";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import classnames from 'classnames';
import invariant from 'invariant';
import Select from '../select';
import { staticFormatMessage as formatMessage } from '../locale';
import './style/index';

var PhoneNumber = function PhoneNumber(_ref) {
  var areaCode = _ref.areaCode,
      phoneNumber = _ref.phoneNumber,
      className = _ref.className,
      disabled = _ref.disabled,
      value = _ref.value,
      formChangeProps = _ref.onChange,
      style = _ref.style;
  invariant(Array.isArray(areaCode) ? areaCode.length : true, 'areaCode cant be an empty array');
  invariant(areaCode != undefined, 'areaCode must be set');

  var _useState = useState(Array.isArray(areaCode) ? areaCode[0] : areaCode),
      _useState2 = _slicedToArray(_useState, 2),
      selectedCode = _useState2[0],
      changeCode = _useState2[1];

  var _useState3 = useState(value ? value.phoneNumber : undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      number = _useState4[0],
      setNumber = _useState4[1];

  useEffect(function () {
    setNumber(value ? value.phoneNumber : undefined);
  }, [value]);
  var leftPart = Array.isArray(areaCode) ? _jsx(Select, {
    disabled: disabled,
    onChange: function onChange(e) {
      changeCode(e);
      formChangeProps(number ? {
        areaCode: e,
        phoneNumber: number
      } : undefined);
    },
    className: classnames('igloo-phone-number-select'),
    defaultValue: selectedCode,
    options: areaCode.map(function (area) {
      return {
        label: area,
        value: area
      };
    })
  }) : _jsx("div", {
    className: "igloo-phone-number-addon-before",
    children: areaCode
  });
  return _jsxs("div", {
    style: style,
    className: classnames('igloo-input-phone', {
      'igloo-input-phone-disabled': disabled
    }, className),
    children: [leftPart, _jsx(_Input, {
      type: "tel",
      value: number,
      onChange: function onChange(e) {
        setNumber(e.target.value);
        formChangeProps(e.target.value ? {
          areaCode: selectedCode,
          phoneNumber: e.target.value
        } : undefined);
      },
      disabled: disabled
    })]
  });
};

PhoneNumber.formItemPropsHandler = function (_ref2) {
  var areaCode = _ref2.areaCode,
      phoneNumber = _ref2.phoneNumber,
      length = _ref2.length,
      maxLength = _ref2.maxLength,
      minLength = _ref2.minLength,
      label = _ref2.label,
      pattern = _ref2.pattern;
  var rules = [{
    validator: function validator(rule, value) {
      if (!value) return Promise.resolve();
      var phoneNumber = value.phoneNumber;
      var pattern = /^[0-9]*$/;
      return pattern.test(phoneNumber) ? Promise.resolve() : Promise.reject(formatMessage({
        id: 'Numbers only, please omit " " or "-".'
      }));
    }
  }];

  if (length !== undefined) {
    rules.push({
      validator: function validator(_, value) {
        if (value === undefined || value === null || value.phoneNumber.length === length) return Promise.resolve();
        return Promise.reject(formatMessage({
          id: '{label} must be {length} digits.',
          values: {
            length: length,
            label: label
          }
        }));
      }
    });
  }

  if (maxLength !== undefined && minLength !== undefined) {
    rules.push({
      validator: function validator(_, value) {
        if (value === undefined || value === null || value.phoneNumber.length >= minLength && value.phoneNumber.length <= maxLength) return Promise.resolve();
        return Promise.reject(formatMessage({
          id: '{label} must be {minLength} - {maxLength} digits.',
          values: {
            maxLength: maxLength,
            minLength: minLength,
            label: label
          }
        }));
      }
    });
  }

  if (maxLength !== undefined && minLength === undefined) {
    rules.push({
      validator: function validator(_, value) {
        if (value === undefined || value === null || value.phoneNumber.length <= maxLength) return Promise.resolve();
        return Promise.reject(formatMessage({
          id: '{label} must be less than {maxLength} digits.',
          values: {
            maxLength: maxLength,
            label: label
          }
        }));
      }
    });
  }

  if (maxLength === undefined && minLength !== undefined) {
    rules.push({
      validator: function validator(_, value) {
        if (value === undefined || value === null || value.phoneNumber.length >= minLength) return Promise.resolve();
        return Promise.reject(formatMessage({
          id: '{label} must be at least {minLength} digits.',
          values: {
            minLength: minLength,
            label: label
          }
        }));
      }
    });
  }

  if (pattern) {
    rules.push({
      validator: function validator(_, value) {
        if (value === undefined || value === null || new RegExp(pattern).test(value.phoneNumber)) return Promise.resolve();
        return Promise.reject(formatMessage({
          id: '{label} must match the pattern {pattern}.',
          values: {
            pattern: pattern,
            label: label
          }
        }));
      }
    });
  }

  return {
    initialValue: phoneNumber ? {
      areaCode: Array.isArray(areaCode) ? areaCode[0] : areaCode,
      phoneNumber: phoneNumber
    } : undefined,
    rules: rules,
    previewFormater: function previewFormater(_ref3) {
      var areaCode = _ref3.areaCode,
          phoneNumber = _ref3.phoneNumber;
      return "".concat(areaCode).concat(phoneNumber);
    }
  };
};

export default PhoneNumber;